<app-popup
  [isOpen]="isShowProfile"
  (close)="isShowProfile = false"
  [hasHeaderContent]="true"
  [hasFooterContent]="true"
  [width]="'500px'"
>
  <div popup-header>
    <!-- <div class="modal-header-top mb-2">
      <span class="modal-badge completed" *ngIf="employeeInfo.personType">{{ getPersonType(employeeInfo?.personType) }}
      </span>
    </div> -->

    <!-- Profile Header Layout -->
    <div class="profile-header-layout">
      <div class="profile-photo-section">
        <div class="profile-photo">
          <img
            *ngIf="loadingProfileIamge"
            class="card-img-top-user"
            src="assets/images/image-loading.gif"
            alt="loading"
          />
          <img
            [hidden]="loadingProfileIamge"
            class="img-fluid"
            (load)="onLoadProfileIamge()"
            [src]="imageUrl"
            alt="Employee Profile Image"
          />
        </div>
        <div class="employee_change_photo" *ngIf="!disableUploadProfile">
          <label title="Upload Photo">
            <a *ngIf="editEnabled"
              ><img
                src="assets/employee/camera.png"
                alt="image"
                class="img-fluid"
              />
              Change Image</a
            >
            <input
              #myInput
              type="file"
              id="upload"
              accept="image/*"
              class="form-control"
              (change)="handleFileInput($event.target.files)"
              placeholder="Upload Photo"
            />
          </label>
        </div>
      </div>
      <div class="profile-info-section">
        <div
          style="height: 22px; margin-bottom: 15px"
          class="spinner-todo"
          *ngIf="isProfileLoading"
        >
          <div class="row">
            <span
              class="col-md-12 mt-1"
              style="padding-left: 17px; bottom: -4px; font-size: 16px"
            >
              Loading...
              <span
                class="spinner-border spinner-border-sm mr-1 custom-spinner"
                style="color: rgb(66, 66, 236)"
              ></span>
            </span>
          </div>
        </div>
        <div class="profile-name-row">
          <span class="profile-name"
            >{{ employeeInfo?.firstName }} {{ employeeInfo?.lastName }}</span
          >
          <button
            class="profile-edit-btn"
            (click)="enableEditOption()"
            title="Edit Profile"
          >
            <mat-icon>edit</mat-icon>
          </button>
        </div>
        <div
          class="profile-role"
          *ngIf="
            employeeInfo?.currentCareer &&
            (currentPersonType == 'E' || currentPersonType == 'C')
          "
        >
          {{ employeeInfo?.currentCareer }}
        </div>
        <div
          class="profile-cq-badge"
          *ngIf="
            employeeInfo?.cq &&
            (currentPersonType == 'E' || currentPersonType == 'C')
          "
        >
          <span>CQ:</span>
          <span>{{ employeeInfo?.cq ?? "??" }}</span>
        </div>
      </div>
    </div>
  </div>
  <div>
    <!-- Employment Details Section -->
    <div *ngIf="currentPersonType == 'E' || currentPersonType == 'C'">
      <div class="modal-section">
        <div class="modal-section-title">Person Details</div>
        <div class="profile-details-grid">
          <div class="detail-item" *ngIf="employeeInfo?.hireDate">
            <div class="detail-label">Hire Date</div>
            <div class="detail-value">
              {{ employeeInfo?.hireDate ?? "N/A" | localDate }}
            </div>
          </div>
          <div class="detail-item">
            <div class="detail-label">Time In Role</div>
            <div class="detail-value">
              {{ employeeInfo?.timeInRole ?? "N/A" }}
            </div>
          </div>
          <div class="detail-item">
            <div class="detail-label">Performance</div>
            <div class="detail-value">
              {{ employeeInfo?.performance ?? "N/A" }}
            </div>
          </div>
          <div class="detail-item">
            <div class="detail-label">Current Career</div>
            <div class="detail-value">
              {{ employeeInfo?.currentCareer ?? "N/A" }}
            </div>
          </div>
          <div class="detail-item full-width">
            <div class="detail-label">Manager</div>
            <div
              class="detail-value"
              [ngClass]="!employeeInfo?.manager ? 'error' : ''"
            >
              {{ employeeInfo?.manager ?? "No Employee Manager Found" }}
            </div>
          </div>
        </div>
      </div>
      <div class="modal-section">
        <div class="modal-section-title">Preferences</div>
        <div class="detail-item flex-item">
          <div>
            <p class="item"><strong>Willing to Relocate</strong></p>
            <p class="hint mb-0">
              Open to job opportunities in other locations
            </p>
          </div>
          <div>
            <p
              class="item no"
              *ngIf="!editEnabled"
              [ngClass]="isRelocateY ? 'yes' : 'no'"
            >
              {{ isRelocateY ? "Yes" : "No" }}
            </p>
            <li *ngIf="editEnabled">
              <input
                type="checkbox"
                class="example-margin"
                color="primary"
                [checked]="isRelocateY"
                (change)="WillRelocate(true, $event.target.checked)"
              />Y
              <!-- [checked]="!employeeInfo.isRelocate" -->
              <input
                type="checkbox"
                class="example-margin"
                color="warn"
                [checked]="isRelocateN"
                (change)="WillRelocate(false, $event.target.checked)"
              />N
            </li>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-section">
      <div class="modal-section-title">🔐 Security Settings</div>
      <div class="detail-item">
        <div
          class="flex-item"
          style="border-bottom: 1px solid #6b7280; margin-bottom: 7px"
        >
          <div>
            <p class="item"><strong>One-Time Password (OTP)</strong></p>
            <p class="hint mb-0">Extra security for login verification</p>
          </div>
          <div>
            <li *ngIf="!editEnabled" style="color: #2f2f2f">
              {{ otpLoginEnabled ? "Yes" : "No" }}
            </li>
            <mat-slide-toggle
              *ngIf="editEnabled"
              [disabled]="disableToggole"
              style="margin-right: 10px; z-index: 0; padding-bottom: 10px"
              color="primary"
              [checked]="otpLoginEnabled"
              (change)="onToggleChange($event)"
            >
            </mat-slide-toggle>
          </div>
        </div>
        <div
          class="flex-item"
          style="border-bottom: 1px solid #6b7280; margin-bottom: 7px"
        >
          <div>
            <p class="item">
              <strong>SMS Notifications</strong>
              <span
                class="information"
                title="Receive verification codes via text"
                >i</span
              >
            </p>
            <p class="hint mb-0">Receive verification codes via text</p>
          </div>
          <div>
            <li *ngIf="!editEnabled" style="color: #2f2f2f">
              {{ smsOption ? "Yes" : "No" }}
            </li>
            <mat-checkbox
              *ngIf="editEnabled"
              [disabled]="disableSmsOption"
              [(ngModel)]="smsOption"
              (change)="applyChanges($event)"
            >
            </mat-checkbox>
          </div>
        </div>
        <div class="mt-2">
          <button class="change-password-button" (click)="changePassword()">
            <mat-icon>lock</mat-icon>
            Change Password
          </button>
        </div>
      </div>
    </div>
    <div class="modal-section">
      <div class="modal-section-title">Self-Identified Information</div>
      <div class="detail-item">
        <p class="hint mb-0" style="line-height: 1.2">
          While not mandatory, this data is useful in scoring assessments
          against statistical norms, and thus providing more accurate career
          recommendations.
        </p>
        <div class="flex-item">
          <div>
            <p class="item"><strong>Race/Ethnicity</strong></p>
          </div>
          <div>
            <form class="d-flex justify-content-between">
              <li *ngIf="!editEnabled" style="color: #2f2f2f">
                <ng-container *ngIf="selectedRaces?.length; else noRace">
                  <span *ngFor="let item of selectedRaces; let i = index">
                    {{ item.name
                    }}<span *ngIf="i < selectedRaces.length - 1">, </span>
                  </span>
                </ng-container>
                <ng-template #noRace>N/A</ng-template>
              </li>

              <div class="employee_self_inner_form" *ngIf="editEnabled">
                <div class="select">
                  <form #raceIds="ngForm">
                    <ng-multiselect-dropdown
                      *ngIf="data"
                      [placeholder]="'Select Race'"
                      [settings]="dropdownSettings"
                      [data]="data"
                      [(ngModel)]="selectedRaces"
                      name="selectedRace"
                      #selectedRace="ngModel"
                      (onDeSelect)="onDeSelectItem($event)"
                      (onSelect)="onItemSelect($event)"
                      [disabled]="!editEnabled"
                    >
                    </ng-multiselect-dropdown>
                  </form>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div popup-footer class="w-100 d-flex gap-2">
    <button *ngIf="!editEnabled" class="modal-btn" (click)="logout()">
      <mat-icon>power_settings_new</mat-icon> Logout
    </button>
    <button
      *ngIf="editEnabled"
      class="modal-btn"
      style="background: #7069f8; color: #fff"
      (click)="onSubmit()"
    >
      <span
        *ngIf="
          isProcessing || isSmsOptionProcessing || isOtpLoginEnabledProcessing
        "
        class="spinner-border spinner-border-sm mr-1 custom-spinner"
        style="
          color: rgb(255, 255, 255);
          margin-left: 0px;
          margin-right: 5px;
          width: 14px;
          height: 14px;
        "
      ></span>
      <mat-icon>save</mat-icon> Update
    </button>
    <button *ngIf="editEnabled" class="modal-btn" (click)="cancelClick()">
      <mat-icon>cancel</mat-icon> Cancel
    </button>
  </div>
</app-popup>

<app-image-framing-croping
  *ngIf="showPopup"
  (FileToUpload)="afterApplyCrop($event)"
  (closeShowPopup)="closeShowPopup($event)"
  [showPopup]="showPopup"
  [imageUrl]="imageUrl"
  [fileName]="fileName"
  [fileFormat]="fileFormat"
></app-image-framing-croping>

<!-- old -->

<!-- <div id="employeeDetails" [ngClass]="
    isShowProfile === true
      ? 'employee_detsils_pop employee-active'
      : 'employee_detsils_pop'
  ">
  <div class="employee_detsils_border">
    <div class="closeIcon">
      <span (click)="closeEmployee()">&times;</span>
    </div>
    <div class="employee_detsils_left text-center">
      <h5 class="employee-name">
        {{ employeeInfo.firstName }} {{ employeeInfo.lastName }} <span *ngIf="!editEnabled && employeeInfo.firstName"
          (click)="enableEditOption()" style="color: #6400ff; font-size: 20px;cursor: pointer;"
          matTooltip="Edit Profile"><i class="fas fa-edit"></i></span>
      </h5>
      <div class="employee_detsils_photo">
        <img *ngIf="loadingProfileIamge" class="card-img-top-user" src="assets/images/image-loading.gif"
          alt="loading" />
        <img [hidden]="loadingProfileIamge" class="img-fluid" (load)="onLoadProfileIamge()" [src]="imageUrl"
          alt="Employee Profile Image" />
      </div>
      <div class="employee_change_photo" *ngIf="!disableUploadProfile">
        <label title="Upload Photo">
          <a *ngIf="editEnabled"><img src="assets/employee/camera.png" alt="image" class="img-fluid" />
            Change Image</a>
          <input #myInput type="file" id="upload" accept="image/*" class="form-control"
            (change)="handleFileInput($event.target.files)" placeholder="Upload Photo" />
        </label>
      </div>
      <h5 class="employee-name-web">
        {{ employeeInfo.firstName }} {{ employeeInfo.lastName }} <span
          style="color: #6400ff; font-size: 20px; cursor: pointer;" matTooltip="Edit Profile"
          *ngIf="!editEnabled && employeeInfo.firstName" (click)="enableEditOption()"><i class="fas fa-edit"></i></span>
      </h5>
      <small class="current-career" *ngIf="isEmployee" (click)="onClickCurrentCareer()">
        {{ employeeInfo.currentCareer }}</small>
      <p *ngIf="isEmployee" class="career-recommedation-cart color-two">
        CQ: {{ employeeInfo.cq }}
      </p>
      <div class="employee_change_password">
        <button class="change-password-button" (click)="changePassword()">
          <i class="fa fa-lock"></i>
          Change Password
        </button>
      </div>
      <div style="height: 22px; margin-bottom: 15px " class="spinner-todo" *ngIf="isProfileLoading">
        <div class="row">
          <span class="col-md-12 mt-1" style="padding-left: 17px; bottom: -4px; font-size: 16px">
            Loading...
            <span class="spinner-border spinner-border-sm mr-1 custom-spinner" style="color: rgb(66, 66, 236)"></span>
          </span>
        </div>
      </div>
    </div>
    <div class="employee_detsils_right">
      <div class="employee_right_top_info">
        <ul *ngIf="isEmployee">
          <li>Hire Date : {{ employeeInfo.hireDate | localDate }}</li>
          <li>Time in Role : {{ employeeInfo.timeInRole }}</li>
          <li class="managerName" *ngIf="
              hasManager === true &&
              employeeInfo.manager !== null &&
              employeeInfo.manager !== undefined &&
              employeeInfo.manager !== ''
            ">
            Manager : {{ employeeInfo.manager }}
          </li>
          <li class="managerName" *ngIf="
              hasManager === false &&
              (employeeInfo.manager === null ||
                employeeInfo.manager === undefined ||
                employeeInfo.manager === '')
            ">
            Manager :
            <span style="color: red; font-size: 15px; margin-top: 1px">
              &nbsp;No Employee Manager Found.</span>
          </li>
          <li>Performance : {{ employeeInfo.performance }}</li>
          <li *ngIf="!editEnabled">Willing to Relocate: {{ isRelocateY?'Yes':'No' }}</li>
          <li *ngIf="editEnabled">
            Willing to Relocate?
            <input type="checkbox" class="example-margin" color="primary" [checked]="isRelocateY"
              (change)="WillRelocate(true, $event.target.checked)" />Y
            <input type="checkbox" class="example-margin" color="warn" [checked]="isRelocateN"
              (change)="WillRelocate(false, $event.target.checked)" />N
          </li>
          <li class="current-career">
            Current Career : {{ employeeInfo.currentCareer }}
          </li>
        </ul>
        <ul *ngIf="isApplicant">
          <li>Person Type : {{ employeeInfo.personType }}</li>
          <li>School : {{ employeeInfo.schoolName }}</li>
          <li>Major : {{ employeeInfo.major }}</li>
          <li>GPA : {{ employeeInfo.gpa }}</li>

          <li>Degree Type : {{ employeeInfo.degreeType }}</li>
          <li>
            Target Graduation Date : {{ employeeInfo.targetGraduationDate }}
          </li>
        </ul>
        <ul *ngIf="isStudent">
          <li>Person Type : {{ employeeInfo.personType }}</li>
          <li>School : {{ employeeInfo.schoolName }}</li>
          <form [formGroup]="employeeForm">
            <li *ngIf="!editEnabled">Major: {{ employeeInfo?.major || 'N/A' }}</li>
            <div *ngIf="editEnabled">
              <label for="major">Major:</label>
              <input id="major" formControlName="major" (ngModelChange)="onFieldChange($event)" />
            </div>
            <li *ngIf="!editEnabled">GPA: {{ employeeInfo?.gpa || 'N/A' }}</li>
            <div class="select-dropdown" *ngIf="editEnabled">
              <label for="gpa">GPA:</label>
              <ng-select [items]="gpaValues" [bindLabel]="'value | number: \'1.1-1\''" bindValue="value"
                formControlName="gpa" (change)="onFieldChange($event)">
              </ng-select>
            </div>
            <li *ngIf="!editEnabled">Degree Type: {{ employeeInfo?.degreeType || 'N/A' }}</li>
            <div class="select-dropdown degreeType" *ngIf="editEnabled">
              <label for="degreeType">Degree Type:</label>
              <ng-select [items]="degreeTypes" bindLabel="label" bindValue="value" formControlName="degreeType"
                (change)="onFieldChange($event)">
              </ng-select>
            </div>
            <li *ngIf="!editEnabled">Target Graduation Date: {{ employeeInfo?.targetGraduationDate || 'N/A' }}</li>
            <div class="select-dropdown targetGraduationDate" *ngIf="editEnabled">
              <label for="targetGraduationDate">Target Graduation Date:</label>
              <ng-select [items]="targetGraduationDates" bindLabel="label" bindValue="value"
                formControlName="targetGraduationDate" (change)="onFieldChange($event)">
              </ng-select>
            </div>
          </form>
        </ul>
        <ul *ngIf="!isApplicant && !isEmployee && !isStudent">
          <li>Hire Date : {{ employeeInfo.hireDate | localDate }}</li>
          <li>Time in Role : {{ employeeInfo.timeInRole }}</li>
          <li *ngIf="
              hasManager === true &&
              employeeInfo.manager !== null &&
              employeeInfo.manager !== undefined &&
              employeeInfo.manager !== ''
            ">
            Manager : {{ employeeInfo.manager }}
          </li>
          <li *ngIf="
              hasManager === false &&
              (employeeInfo.manager === null ||
                employeeInfo.manager === undefined ||
                employeeInfo.manager === '')
            ">
            Manager :
            <span style="color: red; font-size: 15px; margin-top: 1px">
              &nbsp;No Employee Manager Found.</span>
          </li>
          <li>Performance : {{ employeeInfo.performance }}</li>
          <li *ngIf="!editEnabled">Willing to Relocate: {{ isRelocateY?'Yes':'No' }}</li>
          <li *ngIf="editEnabled">
            Willing to Relocate?
            <input type="checkbox" class="example-margin" color="primary" [checked]="isRelocateY"
              (change)="WillRelocate(true, $event.target.checked)" [readonly]="!editEnabled" />Y
            <input type="checkbox" class="example-margin" color="warn" [checked]="isRelocateN"
              (change)="WillRelocate(false, $event.target.checked)" [readonly]="!editEnabled" />N
          </li>
        </ul>
        <div class="employee_logout">
          <a (click)="logout()">logout</a>
        </div>

      </div>
      <div>
        <h6>OTP Enabled Status</h6>
        <li *ngIf="!editEnabled" style="color: #2f2f2f;">OTP Enabled: {{ otpLoginEnabled?'Yes':'No' }}</li>
        <mat-slide-toggle *ngIf="editEnabled" style="margin-right: 10px; z-index: 0; padding-bottom: 10px"
          color="primary" [checked]="otpLoginEnabled" (change)="onToggleChange($event)">
        </mat-slide-toggle>
        <li *ngIf="!editEnabled" style="color: #2f2f2f;">SMS Option: {{ smsOption?'Yes':'No' }}</li>
        <mat-checkbox *ngIf="editEnabled" [(ngModel)]="smsOption" (change)="applyChanges($event)">
          SMS Option
          <span>
            <mat-icon (mouseover)="popupShow()" style="color: #6400ff; margin-top: -4px; cursor: pointer;">
              information
            </mat-icon>
          </span>
        </mat-checkbox>


      </div>
      <div class="employee_self_info">
        <h6>Self-identified Information:</h6>
        <p>
          While not mandatory, this data is useful in scoring assessments
          against statical norms, and thus providing more accurate career
          recommendations.
        </p>
      </div>
      <div class="employee_self_info_bottom">
        <div class="employee_self_inner_bottom">
          <form class="d-flex justify-content-between">

            <li *ngIf="!editEnabled" style="color: #2f2f2f;">
              Race/Ethnicity:
              <ng-container *ngIf="selectedRaces?.length; else noRace">
                <span *ngFor="let item of selectedRaces; let i = index">
                  {{ item.name }}<span *ngIf="i < selectedRaces.length - 1">, </span>
                </span>
              </ng-container>
              <ng-template #noRace>N/A</ng-template>
            </li>

            <div class="employee_self_inner_form" *ngIf="editEnabled">
              <label class="race-etinicity">Race/Ethnicity:</label>
              <div class="select">
                <form #raceIds="ngForm">
                  <ng-multiselect-dropdown *ngIf="data" [placeholder]="'Select Race'" [settings]="dropdownSettings"
                    [data]="data" [(ngModel)]="selectedRaces" name="selectedRace" #selectedRace="ngModel"
                    (onDeSelect)="onDeSelectItem($event)" (onSelect)="onItemSelect($event)" [disabled]="!editEnabled">
                  </ng-multiselect-dropdown>
                </form>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="update-button-container">
        <button class="update-button" style="color: #6400ff;" *ngIf="editEnabled"
          (click)="cancelClick()">Cancel</button>
        <button (click)="onSubmit()" class="update-button activeButton" *ngIf="editEnabled"><span
            *ngIf="isProcessing ||isSmsOptionProcessing ||isOtpLoginEnabledProcessing"
            class="spinner-border spinner-border-sm mr-1 custom-spinner"
            style="color: rgb(255, 255, 255);margin-left: 0px; margin-right: 5px; width: 14px; height: 14px;"></span>Update</button>

      </div>
      <div class="employee_logout-bottom">
        <a (click)="logout()">logout</a>
      </div>
    </div>
  </div>
</div>
<div id="myModal" class="modal" *ngIf="isShowPopup === true">
  <div class="modal-content-wrapper">
    <div class="modal-content">
      <p>By submitting this form and entering your phone number above, you agree to receive automated text
        messages from Catalyzr and agree to our
        <a href="https://www.catalyzr.com/terms-of-service" target="_blank" rel="noopener noreferrer">Terms
          of Service</a> and
        <a href="https://www.catalyzr.com/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy
          Policy</a>.
        Consent is not a condition of any purchase. Msg frequency varies. Msg and data rates may apply.
        Reply HELP for help and STOP to cancel.
      </p>
    </div>
    <div class="modal-close">
      <img class="closeBtn" (click)="onClosePopup()" src="assets/login/close.png" alt="">
    </div>
  </div>
</div> -->
